import { GridsterItem } from 'angular-gridster2';

// eslint-disable-next-line no-shadow
export enum WidgetComponent {
  Empty = 'app-widget-empty',
  UserRoles = 'app-widget-users'
}

export type Widget = {
  id?: number;
  item: GridsterItem;
  component: WidgetComponent;
};
